(() => {
  'use strict';

  const ENDPOINT = '/apps/ic-wishlist';
  const CHANGE_EVENT = 'ic:wishlist:changed';
  const MAX_ITEMS = 100;

  let applyingServerState = false;
  let syncTimer = null;
  let loggedIn = false;

  function normalize(items) {
    if (!Array.isArray(items)) return [];

    const byHandle = new Map();

    items.slice(0, MAX_ITEMS).forEach((item) => {
      if (!item || !item.handle) return;

      const clean = {
        id: String(item.id || '').slice(0, 64),
        handle: String(item.handle || '').slice(0, 255),
        title: String(item.title || '').slice(0, 255),
        url: String(item.url || '').slice(0, 500),
        image: String(item.image || '').slice(0, 1000),
        price: Number(item.price || 0),
        priceFormatted: String(item.priceFormatted || '').slice(0, 100),
        currency: String(item.currency || '').slice(0, 16),
        vendor: String(item.vendor || '').slice(0, 255),
        savedAt: item.savedAt || new Date().toISOString()
      };

      const previous = byHandle.get(clean.handle);

      if (!previous || new Date(clean.savedAt) > new Date(previous.savedAt)) {
        byHandle.set(clean.handle, clean);
      }
    });

    return [...byHandle.values()]
      .sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt))
      .slice(0, MAX_ITEMS);
  }

  function merge(localItems, serverItems) {
    return normalize([
      ...(localItems || []),
      ...(serverItems || [])
    ]);
  }

  function sameHandlesAndDates(a, b) {
    const left = normalize(a);
    const right = normalize(b);

    if (left.length !== right.length) return false;

    return left.every(
      (item, index) =>
        item.handle === right[index].handle &&
        item.savedAt === right[index].savedAt
    );
  }

  async function saveCustomerWishlist(items) {
    if (!loggedIn) return;

    const payload = normalize(items);

    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({items: payload})
      });

      if (!response.ok) {
        console.warn(
          '[IC Wishlist Sync] Server rejected wishlist sync.',
          response.status
        );
      }
    } catch (error) {
      console.warn('[IC Wishlist Sync] Wishlist sync failed.', error);
    }
  }

  async function loadCustomerWishlist() {
    if (!window.ICWishlist) return;

    try {
      const response = await fetch(ENDPOINT, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const data = await response.json();
      loggedIn = Boolean(data.loggedIn);

      if (!loggedIn) return;

      const localItems = window.ICWishlist.getItems();
      const merged = merge(localItems, data.items || []);

      if (!sameHandlesAndDates(localItems, merged)) {
        applyingServerState = true;
        window.ICWishlist.replaceItems(merged);
        applyingServerState = false;
      }

      if (!sameHandlesAndDates(data.items || [], merged)) {
        await saveCustomerWishlist(merged);
      }
    } catch (error) {
      console.warn('[IC Wishlist Sync] Initial sync failed.', error);
    }
  }

  function queueSave(items) {
    if (!loggedIn || applyingServerState) return;

    window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(() => {
      saveCustomerWishlist(items);
    }, 450);
  }

  document.addEventListener(CHANGE_EVENT, (event) => {
    const items =
      event.detail && Array.isArray(event.detail.items)
        ? event.detail.items
        : window.ICWishlist
          ? window.ICWishlist.getItems()
          : [];

    queueSave(items);
  });

  function init() {
    if (!window.ICWishlist) {
      window.setTimeout(init, 150);
      return;
    }

    loadCustomerWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();